/*
 *
 * OrderTreatment constants
 *
 */
export const scope = "app/OrderTreatment/";

export const DEFAULT_ACTION = `${scope}DEFAULT_ACTION`;

export const GET_PATIENT = "app/OrderTreatment/GET_PATIENT";
export const GET_PATIENT_SUCCESS = "app/OrderTreatment/GET_PATIENT_SUCCESS";
export const GET_PATIENT_ERROR = "app/OrderTreatment/GET_PATIENT_ERROR";

export const GET_END_TYPE_PRODUCTS = "app/OrderTreatment/GET_END_TYPE_PRODUCTS";
export const GET_END_TYPE_PRODUCTS_SUCCESS =
  "app/OrderTreatment/GET_END_TYPE_PRODUCTS_SUCCESS";
export const GET_END_TYPE_PRODUCTS_ERROR =
  "app/OrderTreatment/GET_END_TYPE_PRODUCTS_ERROR";

export const GET_INSURERS = "app/OrderTreatment/GET_INSURERS";
export const GET_INSURERS_SUCCESS = "app/OrderTreatment/GET_INSURERS_SUCCESS";
export const GET_INSURERS_ERROR = "app/OrderTreatment/GET_INSURERS_ERROR";

export const GET_DENTISTS = "app/OrderTreatment/GET_DENTISTS";
export const GET_DENTISTS_SUCCESS = "app/OrderTreatment/GET_DENTISTS_SUCCESS";
export const GET_DENTISTS_ERROR = "app/OrderTreatment/GET_DENTISTS_ERROR";

export const CREATE_PRODUCT_PLAN = "app/OrderTreatment/CREATE_PRODUCT_PLAN";
export const CREATE_PRODUCT_PLAN_SUCCESS =
  "app/OrderTreatment/CREATE_PRODUCT_PLAN_SUCCESS";
export const CREATE_PRODUCT_PLAN_ERROR =
  "app/OrderTreatment/CREATE_PRODUCT_PLAN_ERROR";

export const UPDATE_PRODUCT_PLAN = "app/OrderTreatment/UPDATE_PRODUCT_PLAN";
export const UPDATE_PRODUCT_PLAN_SUCCESS =
  "app/OrderTreatment/UPDATE_PRODUCT_PLAN_SUCCESS";
export const UPDATE_PRODUCT_PLAN_ERROR =
  "app/OrderTreatment/UPDATE_PRODUCT_PLAN_ERROR";

export const GET_ACTIVE_PRODUCT_PLAN =
  "app/OrderTreatment/GET_ACTIVE_PRODUCT_PLAN";
export const GET_ACTIVE_PRODUCT_PLAN_SUCCESS =
  "app/OrderTreatment/GET_ACTIVE_PRODUCT_PLAN_SUCCESS";
export const GET_ACTIVE_PRODUCT_PLAN_ERROR =
  "app/OrderTreatment/GET_ACTIVE_PRODUCT_PLAN_ERROR";

export const SET_PRODUCT_PLAN = "app/OrderTreatment/SET_PRODUCT_PLAN";
export const SET_ACTIVE_ORDER_ID = "app/OrderTreatment/SET_ACTIVE_ORDER_ID";
export const RESET = "app/OrderTreatment/RESET";

export const DELETE_ORDER = "app/OrderTreatment/DELETE_ORDER";
export const DELETE_ORDER_SUCCESS = "app/OrderTreatment/DELETE_ORDER_SUCCESS";
export const DELETE_ORDER_ERROR = "app/OrderTreatment/DELETE_ORDER_ERROR";
